import * as React from 'react'

interface SearchItemProps {
  item: any
  onClick: (id: number) => void
}

interface SearchItemState {

}


class SearchItem extends React.Component<SearchItemProps, SearchItemState> {

  handleSearchItemClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    this.props.onClick(this.props.item.articleId)
  }

  render () {
    const title = {
      __html: this.props.item.articleTitle
    }

    const content = {
      __html: Array.isArray(this.props.item.highlight)
        ? this.props.item.highlight.join(' ... ')
        : this.props.item.highlight
    }

    return (
      <a href="#" className="list-group-item list-group-item-action flex-column align-items-start" onClick={this.handleSearchItemClick}>
        <div className="d-flex w-100 justify-content-between">
          <h5 className="mb-1" dangerouslySetInnerHTML={title}></h5>
        </div>
        <p className="mb-1" dangerouslySetInnerHTML={content}></p>
        <small className="text-muted">{this.props.item.categoryName}</small>
      </a>
    )
  }
}

export {
  SearchItem
}
